import tpl from './developDeploy.html';
import "./developDeploy.css";

class DevelopDeploy {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
    }
}

export {
    DevelopDeploy
}